var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillJobIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.38672V9.88672H0V2.38672H3.75V1.63672C3.75 1.53125 3.76953 1.43359 3.80859 1.34375C3.84766 1.25391 3.90039 1.17578 3.9668 1.10938C4.03711 1.03906 4.11719 0.984375 4.20703 0.945312C4.29688 0.90625 4.39453 0.886719 4.5 0.886719H7.5C7.60547 0.886719 7.70312 0.90625 7.79297 0.945312C7.88281 0.984375 7.96094 1.03906 8.02734 1.10938C8.09766 1.17578 8.15234 1.25391 8.19141 1.34375C8.23047 1.43359 8.25 1.53125 8.25 1.63672V2.38672H12ZM4.5 2.38672H7.5V1.63672H4.5V2.38672ZM0.75 3.13672V4.2207L4.5 6.08984V5.38672H7.5V6.08984L11.25 4.2207V3.13672H0.75ZM5.25 6.13672V6.88672H6.75V6.13672H5.25ZM11.25 9.13672V5.05273L7.5 6.93359V7.63672H4.5V6.93359L0.75 5.05273V9.13672H11.25Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillJobIcon);
export default __webpack_public_path__ + "static/media/SkillJobIcon.4ff5a317d3becdb6f731f92b119d5402.svg";
export { ForwardRef as ReactComponent };